import { useState } from "react";
import ModuleAddEdit from "./ModuleAddEdit";
import Button from "../../ui/Button";
import { AddIcon, CrossIcon, DeleteIcon, DoneIcon, EditIcon } from "../../utils/icon.utils";
import Table from "../../ui/Table/Table";
import { GroupBtn } from "../../ui/GroupBtn";
import {
  useAssignModulePermissionMutation,
  useDeleteModuleMutation,
  useGetAllModuleQuery
} from "../../utils/module.utils";
import { tableIndex } from "../../utils/table.utils";
import { onConfirm } from "../../utils/sweetAlert.utils";
import Loading from "../../components/Loading";
import { useGetAllPermissionQuery } from "../../utils/permission.utils";
import { arrayMap, checkTextInArray } from "../../utils/array.utils";
import PageLayout from "../../layouts/PageLayout";

export default function ModulePage() {
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [editItem, setEditItem] = useState(null);

  const [modal, setModal] = useState(false);

  const toggle = () => {
    if (modal) {
      setEditItem(null);
    }
    setModal((prev) => !prev);
  };

  const { loading: assignLoading, assignModulePermission } = useAssignModulePermissionMutation([
    "assignModulePermission"
  ]);

  const { loading: permissionLoading, data: permissionData } = useGetAllPermissionQuery({
    query: ``
  });

  const { loading, data } = useGetAllModuleQuery({
    query: `?page=${currentPage}&size=${pageSize}`
  });

  const { loading: deleting, deleteModule } = useDeleteModuleMutation(["deleteModule"]);

  const totalPage = data?.last_page === 1 && data?.total === 0 ? 0 : data?.last_page;

  const breadCrumbs = [
    {
      name: "Settings",
      link: "/settings"
    },
    {
      name: "Module"
    }
  ];

  const thead = ["#", "Name", "Slug", "Permissions", "Action"];

  const Permissions = ({ data: permissionItems, permissions, moduleId }) => {
    const existPermissions = arrayMap([...(permissionItems ?? [])], (item) => item?.id) || [];
    const newPermissions = [...permissions];
    const newPermissionsLength = newPermissions.length;
    if (newPermissionsLength === 0) {
      return "No permissions";
    }
    const btns =
      arrayMap(newPermissions, (permissionItem, index) => {
        const permissionId = permissionItem?.id;
        const isTag = checkTextInArray([...existPermissions], permissionId);
        const color = isTag ? "success" : "danger";
        const name = permissionItem?.name ?? index + 1;
        const icon = isTag ? DoneIcon : CrossIcon;

        const handleAssignModulePermission = async () => {
          await assignModulePermission({
            module_id: moduleId,
            permissions: [permissionId]
          });
        };

        return {
          name: name,
          color: color,
          icon,
          onClick: () => handleAssignModulePermission()
        };
      }) || [];

    return <GroupBtn justify="start" btns={btns} loading={assignLoading} />;
  };

  const tbody =
    arrayMap(data?.data, (item, index) => ({
      "#": tableIndex(index, currentPage, pageSize),
      Name: item?.name ?? "-",
      Slug: item?.slug ?? "-",
      Permissions: (
        <Permissions
          moduleId={item?.id}
          data={item?.app_permissions ?? []}
          permissions={permissionData ?? []}
        />
      ),
      ...item
    })) || [];

  const ActionComponent = ({ data }) => {
    const handleEdit = (item) => {
      setEditItem(item);
      toggle();
    };

    const handleDelete = async (item) => {
      const { isConfirmed } = await onConfirm();
      if (isConfirmed) {
        await deleteModule(item?.id);
      }
    };

    const btns = [
      {
        icon: DeleteIcon,
        onClick: () => handleDelete(data),
        color: "danger"
      },
      {
        icon: EditIcon,
        onClick: () => handleEdit(data),
        color: "primary"
      }
    ];
    return <GroupBtn btns={btns} justify="start" />;
  };

  const isLoading = loading || deleting || permissionLoading;

  return (
    <PageLayout title="Module" subTitle={`Total: ${data?.total ?? 0}`} breadCrumbs={breadCrumbs}>
      <div className="text-end">
        <Button color="primary" icon={AddIcon} name="Create Module" onClick={toggle} />
      </div>

      {loading ? "Loading..." : ""}

      <Table
        thead={thead}
        tbody={tbody}
        action={ActionComponent}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
      />

      {modal && <ModuleAddEdit modal={modal} toggle={toggle} editItem={editItem} />}
      {<Loading loading={isLoading} />}
    </PageLayout>
  );
}
